export default "__VITE_ASSET__DWaVOucW__"